import React from 'react';

import styled from 'styled-components';

import OverviewCommunities from './OverviewCommunities';
import OverviewCompetitors from './OverviewCompetitors';
import OverviewHeader from './OverviewHeader';
import OverviewMap from './OverviewMap';
import OverviewStats from './OverviewStats';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  padding: 30px 20px;
  background-color: var(--background-gray);
  gap: 20px;
`;

const OverviewContent = () => {
  return (
    <Container>
      <OverviewHeader />
      <Content>
        <OverviewMap />
        <OverviewStats />
        <OverviewCommunities />
        <OverviewCompetitors />
      </Content>
    </Container>
  );
};

export default OverviewContent;
